export default "__VITE_PUBLIC_ASSET__cafe15b5__"